import React, {useState} from 'react';
import ConfirmModal from "../ConfirmModal/ConfirmModal";
import {Prompt, useHistory} from 'react-router-dom';
import {connect} from 'react-redux';
import * as actionTypes from '../../../redux/constants';
import {Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

export const ConfirmUnSavedData = (props) => {
    const {t} = useTranslation();

    return (
        <ConfirmModal
            actionOk={props.actionOk}
            actionCancel={props.actionCancel}
        >
            <Typography component={'p'} variant={'body1'}>
                {t('Global.unsaved_prompt')}
            </Typography>
        </ConfirmModal>
    )
};

const UnSavedDataPrompt = (props) => {

    const [state, setState] = useState({
        navigationConfirmed: false,
        showModal: false,
        lastLocation: null
    });

    let history = useHistory();

    const handleBlockedNavigation = (nextLocation) => {
        if (!state.navigationConfirmed && props.when && nextLocation !== null) {
            setState({
                ...state,
                showModal: true,
                lastLocation: nextLocation
            });
            return false;
        }
        return true;
    };

    let confirm = null;
    if (state.showModal) {
        confirm = <ConfirmUnSavedData
            actionOk={() => {
                setState({
                    ...state,
                    navigationConfirmed: false,
                    showModal: false
                });

                setTimeout(() => {
                    props.clearSavedNotifications();
                    history.push(state.lastLocation);
                }, 10);

            }}
            actionCancel={() => {
                setState({
                    ...state,
                    navigationConfirmed: false,
                    showModal: false
                });
            }}
        />
    }

    return (
        <div>
            <Prompt
                when={props.when}
                message={handleBlockedNavigation}
            />
            {confirm}
        </div>
    );
};


const mapDispatchToProps = (dispatch) => {
    return {
        clearSavedNotifications: () => dispatch({
            type: actionTypes.SET_HAS_EDITABLE_CONTENT,
            data: false
        })
    }
};

export default connect(null, mapDispatchToProps)(UnSavedDataPrompt);